/**
 * ExecutionPanel — Lightweight execution destination (no Expert AI).
 * Surfaces live warnings and notes guidance for day-to-day use.
 */
export function ExecutionPanel({ decision, notes }) {
  const warnings = Array.isArray(decision?.warnings) ? decision.warnings : [];

  return (
    <div className="flex flex-col flex-1 min-h-0 p-4 gap-4 overflow-y-auto" data-testid="execution-panel">
      <div>
        <h2 className="text-[15px] font-semibold text-gray-900 tracking-tight">Execution</h2>
        <p className="text-[12px] text-gray-500 mt-1 leading-snug">
          Watch risks and notes while you structure the deal. AI survival review was removed.
        </p>
      </div>

      <section className="rounded-xl border border-black/10 bg-white p-3">
        <h3 className="text-[12px] font-semibold text-gray-800 mb-2">Live warnings</h3>
        {warnings.length === 0 ? (
          <p className="text-[12px] text-gray-400">No active warnings.</p>
        ) : (
          <ul className="space-y-1.5">
            {warnings.map((w, i) => (
              <li key={i} className="text-[12px] text-amber-800 bg-amber-50 border border-amber-100 rounded-lg px-2.5 py-2">
                {typeof w === 'string' ? w : w?.message || JSON.stringify(w)}
              </li>
            ))}
          </ul>
        )}
      </section>

      <section className="rounded-xl border border-black/10 bg-white p-3">
        <h3 className="text-[12px] font-semibold text-gray-800 mb-2">Notes</h3>
        <p className="text-[12px] text-gray-600 whitespace-pre-wrap min-h-[80px] leading-relaxed">
          {notes?.trim() ? notes : 'No notes yet. Capture structure decisions in the main notes field.'}
        </p>
      </section>
    </div>
  );
}
